import { FormControl, Radio, RadioGroup } from '@ifs-gcp/components';

import type { AnswerProps } from '@/types/question';
import { getTranslation } from '@/utils/translations';

export const RadioAnswer = ({
  answer,
  error,
  language,
  onBlur,
  onChange,
  question: {
    props: {
      id: questionId,
      alignment,
      disabledCondition,
      readOnlyCondition,
      deselectableCondition,
      options = [],
    },
  },
}: AnswerProps<string>) => {
  return (
    <FormControl error={Boolean(error)} helperText={error}>
      <RadioGroup alignment={alignment} value={answer}>
        {options.map(({ value: optionValue, text, disabledCondition: optionDisabledCondition }) => (
          <Radio
            key={optionValue}
            onBlur={() => {
              if (onBlur) {
                onBlur(answer);
              }
            }}
            onClick={(event: React.BaseSyntheticEvent) => {
              if (event.target.value === answer) {
                if (deselectableCondition) {
                  onChange('');
                } else {
                  return;
                }
              } else {
                onChange(event.target.value);
              }

              if (onBlur) {
                onBlur(answer);
              }
            }}
            label={getTranslation(text, language)}
            value={optionValue}
            disabled={Boolean(readOnlyCondition || disabledCondition || optionDisabledCondition)}
            inputProps={{
              id: `${questionId}_${optionValue}`,
            }}
          />
        ))}
      </RadioGroup>
    </FormControl>
  );
};
